import { render, staticRenderFns } from "./edituser.vue?vue&type=template&id=35f70106&scoped=true"
import script from "./edituser.vue?vue&type=script&lang=js"
export * from "./edituser.vue?vue&type=script&lang=js"
import style0 from "./edituser.vue?vue&type=style&index=0&id=35f70106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f70106",
  null
  
)

export default component.exports